/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import Loading from 'quasar/src/plugins/Loading.js';;
import http from '../../http/http';
import { success, error } from '../../../../../services/alert-message';

const urlApi = '';

/**
* Buscando todos atos
* @param {*} param0
*/
export async function consultaBasica({ commit }, obj) {
  Loading.show({ message: 'Pesquisando...' });
  return (await http.get(`central/api/v1/consulta-basica?${obj.page}&${obj.filter}&include[servicos.livros]`)
    .then(res => {
      Loading.hide();
      commit('SET_SERVICOS_BASICOS', res.data);
      this.$router.push({ name: 'cei-consulta-servico' });
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}
